/** Small, exclusive dialog context shared by search and add-to-cart. */
(function () {
  'use strict';

  var active = null;
  var inerted = [];
  var savedOverflow = '';

  function outsideElements(dialog) {
    var elements = [];
    var node = dialog;
    while (node && node.parentElement) {
      Array.prototype.forEach.call(node.parentElement.children, function (sibling) {
        if (sibling !== node && elements.indexOf(sibling) === -1) elements.push(sibling);
      });
      node = node.parentElement;
      if (node === document.body) break;
    }
    return elements;
  }

  function makeBackgroundInert(dialog) {
    inerted = outsideElements(dialog).map(function (element) {
      var hadInert = element.hasAttribute('inert');
      if (!hadInert) element.setAttribute('inert', '');
      return { element: element, hadInert: hadInert };
    });
  }

  function restoreBackground() {
    inerted.forEach(function (entry) {
      if (!entry.hadInert) entry.element.removeAttribute('inert');
    });
    inerted = [];
  }

  function focusable(dialog) {
    return Array.prototype.filter.call(dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ), function (element) {
      // Shopify contact forms include hidden inputs; disabled fieldsets and
      // negative tabindex controls also fall outside sequential keyboard focus.
      if (element.type === 'hidden' || element.tabIndex < 0 || element.matches(':disabled')) return false;
      for (var node = element; node; node = node.parentElement) {
        if (node.hidden || node.hasAttribute('inert') || node.getAttribute('aria-hidden') === 'true') return false;
      }
      var style = window.getComputedStyle(element);
      return style.visibility !== 'hidden' && style.visibility !== 'collapse' &&
        style.display !== 'none' && element.getClientRects().length > 0;
    });
  }

  function close(token, restoreFocus) {
    if (!active || (token && active.token !== token)) return false;
    var closing = active;
    active = null;
    restoreBackground();
    document.documentElement.style.overflow = savedOverflow;
    if (restoreFocus !== false && closing.trigger && typeof closing.trigger.focus === 'function') closing.trigger.focus();
    return true;
  }

  function open(options) {
    if (!options || !options.element) return null;
    if (active && typeof active.onRequestClose === 'function') active.onRequestClose(false);
    if (active) close(active.token, false);

    var token = {};
    savedOverflow = document.documentElement.style.overflow || '';
    active = {
      token: token,
      element: options.element,
      trigger: options.trigger || document.activeElement,
      initialFocus: options.initialFocus || null,
      onRequestClose: options.onRequestClose
    };
    makeBackgroundInert(options.element);
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () {
      if (!active || active.token !== token) return;
      var target = active.initialFocus || focusable(active.element)[0];
      if (target && typeof target.focus === 'function') target.focus();
    }, 0);
    return token;
  }

  document.addEventListener('keydown', function (event) {
    if (!active) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      if (typeof active.onRequestClose === 'function') active.onRequestClose(true);
      return;
    }
    if (event.key !== 'Tab') return;
    var nodes = focusable(active.element);
    if (!nodes.length) {
      event.preventDefault();
      if (active.initialFocus) active.initialFocus.focus();
      return;
    }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (!active.element.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  window.PGDialogs = { open: open, close: close };
})();
